import { Box, Button, Card, Container, InputBase, Stack, Table, TableBody, TableCell, TableContainer, TableRow, Paper, Typography, Dialog, DialogTitle, DialogContent, TextField, DialogActions, MenuItem, Popover, Select, TableHead, CircularProgress, DialogContentText, FormControl, InputLabel, OutlinedInput, Chip, Tabs, Tab, Grid } from '@mui/material';
import React, { useEffect, useState, useRef } from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import { Helmet } from 'react-helmet-async';
import { toast } from 'react-toastify';
import Iconify from 'src/components/iconify';
import { getData, patchData, postData, putData, uploadFile } from 'src/webService/webService';
import PaginationComponent from 'src/components/pagination';
import wordIcon from '../../components/logo/icons-word.png'
import pdfIcon from '../../components/logo/icons-pdf.png'
import { file_URL } from '../../utils/url'

function CameraTeam() {

    const [open, setOpen] = useState(null)
    const [formOpen, setFormOpen] = useState(false);
    const [convertForm, setConvertForm] = useState(false);
    const [dailyData, setDailyData] = useState("");
    const [view, setView] = useState([]);
    const [details, setDetails] = useState(false);
    const [scroll, setScroll] = useState('paper');
    const descriptionElementRef = useRef(null);
    const [selectedLead, setSelectedLead] = useState("")
    const [allUpdates, setAllUpdates] = useState([]);

    const [selectedLeadId, setSelectedLeadId] = useState(null);
    const [cameraLeads, setCameraLeads] = useState([]);

    const sessionToken = sessionStorage.getItem("Token");
    const role = sessionStorage.getItem("role");
    const roleType = sessionStorage.getItem("roleType");
    const serviceTeamType = sessionStorage.getItem("serviceTeamType")
    const UserId = sessionStorage.getItem('userId');

    const [selectedFiles, setSelectedFiles] = useState({})
    const [fileUpload, setFileUpload] = useState(null);
    const [selectedWorkUpdateId, setSelectedWorkUpdateId] = useState(null);
    const [employeeOptions, setEmployeeOptions] = useState([]);
    const [assignedLeads, setAssignedLeads] = useState([]);
    const [openImage, setOpenImage] = useState(false);
    const [selectedImage, setSelectedImage] = useState('');
    const [activeTab, setActiveTab] = useState(0);
    const [events, setEvents] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [limit, setLimit] = useState(5);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [editingId, setEditingId] = useState("");
    const [formData, setFormData] = useState({
        shootType: "",
        location: "",
        completionStatus: "",
        comments: "",
        rawFootageUpload: "",
        completedShots: "",
        status: "",
    });

    console.log(view, "View")

    const [convertData, setConvertData] = useState({
        ...(role === "Admin"
            ? {
                projectName: "",
                serviceName: ["Video Editing"],
                deadline: "",
                totalEditingShots: "",
            } : {
                serviceName: ["Camera Man"],
                employeeWork: [],
                employeeWork: {},
                noOfPosters: [],
                deadline: [],
                status: []
            }
        ),
        assignedTo: [],
        assignedEditingShots: "",
        comments: "",
        paymentStatus: ""
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setConvertData((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleMultiSelectChange = (event) => {
        const {
            target: { value },
        } = event;
        setConvertData((prev) => ({
            ...prev,
            assignedTo: typeof value === 'string' ? value.split(',') : value,
        }));
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleOpenMenu = (event, task, id, workUpdateId) => {
        debugger
        let lead;
        getLeadById(id);
        if (task && typeof task === 'object') {
            lead = task;
            setSelectedLead(lead);
        }
        else {
            lead = assignedLeads.find((data) => data._id === id);
            setSelectedLead(lead);
        }

        if (event?.currentTarget) {
            setOpen(event.currentTarget);
            setSelectedLeadId(id);
            setSelectedWorkUpdateId(workUpdateId);
            setView(task);
            setSelectedLead(lead);
        }
    };

    const handleCloseMenu = () => {
        setOpen(null);
    };

    const handleOpenDialog = async (id) => {
        await getAllUpdatesAdmin();
        setDetails(true);
        handleCloseMenu();
    };

    const handleCloseDialog = () => {
        setDetails(false);
    };

    const handleOpen = async () => {
        setFormOpen(true);
        handleCloseMenu();
    }

    const handleClose = () => {
        setFormOpen(false)
    }

    const handleFormOpen = async (leadId) => {
        await getAllUsers();
        setSelectedLeadId(leadId)
        setConvertForm(true)
        setOpen(false)
    }

    const handleFormClose = () => {
        setConvertForm(false)
    }

    const getAllUsers = async () => {
        try {
            const params = { page: 1, limit: 1000 }
            const response = await getData("users/users", params);
            console.log("Response:", response);

            let filteredUsers = [];

            if (role === "Admin") {
                filteredUsers = response.data.results.filter(user =>
                    user.serviceTeamType && user.serviceTeamType.includes("Video Editing") && user.roleType === "Team Leader"
                );
            } else if (roleType === "Team Leader") {
                filteredUsers = response.data.results.filter(user =>
                    user.serviceTeamType && user.serviceTeamType.includes("Camera Man")
                );
            }

            const formattedOptions = filteredUsers.map(user => ({
                id: user._id,
                name: user.name
            }));

            setEmployeeOptions(formattedOptions);
        } catch (error) {
            console.error("Error fetching users:", error);
            toast.error("Failed to load users");
        }
    };

    const fetchAssignedLeads = async () => {
        try {
            let response;
            let cameraLeads = [];

            if (role === "Admin" || roleType === "Team Leader") {
                const params = { page: currentPage, limit: limit, serviceName: "Camera Man" }
                response = await getData("leads/services", params, sessionToken);
                console.log("Admin Response", response);
                cameraLeads = response.data.results[0].paginatedResults;
                setTotalPages(response.data.results[0].totalPages);
                setTotalCount(response.data.results[0].totalCount);
            } else if (roleType === "Employee") {
                const params = {
                    page: currentPage,
                    limit: limit
                };

                const endpoint = `leads/leads/${UserId}`;

                response = await getData(endpoint, params, sessionToken);
                console.log(`${roleType} Response`, response);

                if (roleType === "Employee" && response?.data) {
                    const leadsData = Array.isArray(response.data)
                        ? response.data[0]?.paginatedResults
                        : response.data[0]?.paginatedResults || [];

                    const totalRecords = response.data[0].totalCount.totalItems;
                    setTotalPages(response.data[0].totalPages === null ? 0 : response.data[0].totalPages);
                    setTotalCount(totalRecords);

                    cameraLeads = leadsData
                }
            }


            console.log("Camera Leads", cameraLeads);
            setAssignedLeads(cameraLeads);

            const latestDeadlines = {};
            cameraLeads.forEach(lead => {
                const leadId = lead._id;
                const deadline = lead.cameraHistory?.deadline;
                if (deadline && (!latestDeadlines[leadId] ||
                    new Date(deadline) > new Date(latestDeadlines[leadId].deadline))) {
                    latestDeadlines[leadId] = lead;
                }
            });

            const latestDeadlinesArray = Object.values(latestDeadlines);

            const deadlineEvents = latestDeadlinesArray.map(lead => ({
                id: lead._id + '-deadline',
                title: `Deadline: ${lead.cameraHistory?.contentType || 'Content'}`,
                start: lead.cameraHistory?.deadline,
                allDay: true,
                extendedProps: {
                    type: 'deadline',
                    leadName: lead.name,
                    contentType: lead.cameraHistory?.contentType,
                    progress: lead.cameraHistory?.completionPercentage
                        ? `${Math.round(lead.cameraHistory.completionPercentage)}%`
                        : '0%'
                },
                backgroundColor: '#FF8A80',
                borderColor: '#FF8A80',
                textColor: '#000'
            }));

            setEvents(prevEvents => [...prevEvents, ...deadlineEvents]);

        } catch (err) {
            console.error("Error while fetching Camera Team:", err);
            toast.error("Failed to load Camera Team.");
        }
    };

    const getDailyUpdates = async () => {

        try {
            const response = await getData(`dailyworkupdates/user/${UserId}`, {}, sessionToken);
            console.log("Response Daily Updates:", response)
            const results = response?.data;
            console.log("Results:", results)
            setDailyData(results);

        } catch (err) {
            console.error("Error while fetching Camera Team:", err);
            toast.error("Failed to load Camera Team.");
        }

    }

    const getAllUpdatesAdmin = async () => {

        const params = {
            page: 1,
            limit: 1000
        }

        try {
            const response = await getData("dailyworkupdates/updates", params, sessionToken);
            console.log("Response Dailyyy Updates:", response)

            const filteredData = response?.data[0]?.paginatedResults?.filter(lead => lead.serviceName === "Camera Man");

            console.log("Filtered Data:", filteredData);
            setAllUpdates(filteredData);
            // setView(filteredData);

        } catch (err) {
            console.error("Error while fetching Camera Team:", err);
            toast.error("Failed to load Camera Team.");
        }

    }

    const handleFileChange = (event, leadId) => {
        const file = event.target.files[0];
        if (file) {
            setSelectedFiles(prev => ({ ...prev, [leadId]: file }));
            handleFileUpload(file, leadId);
        }
    };

    const handleFileUpload = async (fileupload, leadId) => {

        console.log("Fileupload:", fileupload);
        console.log("Is File:", fileupload instanceof File);

        const formDataToSend = new FormData();
        formDataToSend.append("file", fileupload);

        try {
            const response = await uploadFile(`files/upload/${selectedLeadId}`, formDataToSend);
            if (response?.status === 200) {
                toast.success("File uploaded successfully!");
                setFileUpload(response?.data);
                setFormData(prevState => ({
                    ...prevState,
                    fileupload: response?.data,
                }));
            } else {
                toast.error("File upload failed!");
            }
        } catch (error) {
            console.error("File upload error:", error);
            toast.error("Error uploading file.");
        }
    };

    const postDailyWorkUpdate = async () => {
        debugger

        try {

            const checkResponse = await getData(`dailyworkupdates/${selectedLeadId}`, {}, sessionToken);
            const existingUpdates = checkResponse?.data?.flatMap(update => update?.cameraHistory?.map(history => history?.dailyUpdateId));

            const cameraHistory = selectedLead?.cameraHistory?.[0] ||
                selectedLead?.cameraHistory ||
                {};
            const assignedShots = selectedLead?.cameraHistory?.[0]?.assignedShots;
            const previousCompleted = cameraHistory.completedShots || 0;
            const newCompleted = parseInt(formData.completedShots, 10) || 0;
            const totalCompleted = previousCompleted + newCompleted;
            const remainingShots = assignedShots - newCompleted;

            const shootType = selectedLead?.cameraHistory?.[0]?.shootType ||
                selectedLead?.cameraHistory?.shootType ||
                '';
            const location = selectedLead?.cameraHistory?.[0]?.location ||
                selectedLead?.cameraHistory?.location ||
                '';

            const deadline = selectedLead?.cameraHistory?.[0]?.deadline ||
                selectedLead?.cameraHistory?.deadline ||
                '';

            const totalShots = selectedLead?.cameraHistory?.[0]?.totalShots ||
                selectedLead?.cameraHistory?.totalShots;

            const amount = selectedLead?.cameraHistory?.[0]?.amount ||
                selectedLead?.cameraHistory?.amount ||
                '';
            const assignedTo = selectedLead?.cameraHistory?.[0]?.assignedTo ||
                selectedLead?.cameraHistory?.assignedTo ||
                '';
            const status = selectedLead?.cameraHistory?.[0]?.completedShots === selectedLead?.cameraHistory?.[0]?.totalShots ? "Completed" : "Pending";

            const payLoad = {
                leadId: selectedLeadId,
                amount,
                assignedTo,
                shootType,
                location,
                comments: formData.comments,
                rawFootageUpload: fileUpload,
                serviceName: "Camera Man",
                deadline,
                totalShots,
                completedShots: totalCompleted,
                userId: UserId,
                assignedShots: remainingShots,
                status,
            }

            let response;

            if (existingUpdates.length === 0) {
                response = await postData('dailyworkupdates', payLoad, sessionToken);
            } else {
                const updateId = existingUpdates[0];
                response = await putData(`dailyworkupdates/dailyworkupdates/${updateId}`, payLoad, sessionToken);
            }

            if (response?.status === 200) {
                toast.success("Daily Work Updated Successfully!");
                handleClose();
                getDailyUpdates();
                fetchAssignedLeads();
            } else {
                throw new Error(response?.message || "Failed to update Daily Work.");
            }

        } catch (error) {
            console.error("Error:", error);
            toast.error(error.message);
        }
    }

    const convertLeads = async () => {
        debugger;
        try {
            const sessionToken = sessionStorage.getItem("Token");
            if (!sessionToken) {
                toast.error("Authentication Error! Please login again.");
                return;
            }

            if (role === "Admin") {
                const payLoad = {
                    projectName: convertData.projectName,
                    assignedTo: convertData.assignedTo,
                    assignedEditingShots: convertData.assignedEditingShots,
                    deadline: convertData.deadline,
                    comments: convertData.comments,
                    totalEditingShots: convertData.totalEditingShots,
                    paymentStatus: convertData.paymentStatus,
                    leadId: selectedLeadId,
                    userId: UserId
                };

                const response = await patchData(`videoediting/videoediting/${editingId}`, payLoad, sessionToken);
                if (response.status === 200) {
                    toast.success("Video Editing Service Assigned successfully!");
                } else {
                    throw new Error(response.message || "Failed to assign Video Editing Service");
                }

            } else if (roleType === "Team Leader") {
                const params = {
                    serviceName: ["Camera Man"],
                    assignedTo: convertData.assignedTo,
                    employeeWork: convertData.employeeWork,
                    serviceStatus: "In Progress",
                    noOfPosters: convertData.noOfPosters,
                    deadline: convertData.deadline,
                    status: convertData.status
                };

                const putResponse = await putData(`leads/lead/${selectedLeadId}/status`, params, sessionToken);
                console.log("Put Response", putResponse);
                if (putResponse.status === 200) {
                    toast.success("Lead Assigned successfully!");
                }
            }

            setConvertForm(false);
            await fetchAssignedLeads();
        } catch (error) {
            console.error("Error converting lead:", error);
            toast.error("Something went wrong while converting the lead.");
        }
    };

    const handleLimitChange = (event) => {
        setCurrentPage(1);
        if (currentPage === 1) {
            setLimit(event.target.value)
            fetchAssignedLeads(1, event.target.value)
        }
        else {
            setCurrentPage(1);
            setLimit(event.target.value);
        }
    };

    const handlePrevPage = () => {
        if (currentPage > 1) {
            setCurrentPage((prev) => prev - 1);
            fetchAssignedLeads(currentPage - 1, limit);
        }
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage((prev) => prev + 1);
            fetchAssignedLeads(currentPage + 1, limit);
        }
    };

    const calculateIndex = (index) => {
        return (currentPage - 1) * limit + index + 1;
    };

    useEffect(() => {
        getAllUsers();
        getAllUpdatesAdmin();
        fetchAssignedLeads(currentPage, limit);
        if (roleType === "Employee") {
            getDailyUpdates();
        }
    }, [currentPage, limit]);

    const teams = cameraLeads.map(task => `Team ${task.id}`);
    const totalVideos = cameraLeads.map(task => task.totalVideos);
    const completedVideos = cameraLeads.map(task => task.completedVideos);
    const pendingVideos = totalVideos.map((total, index) => total - completedVideos[index]);

    pendingVideos.forEach((pending, index) => {
        if (pending > 5) {
            console.log(`Notification: Team ${cameraLeads[index].id} has ${pending} pending videos!`);
        }
    });

    const getLeadById = async (id) => {
        debugger
        try {
            const response = await getData(`leads/lead/${id}`, {}, sessionToken)
            if (response.status === 200) {
                console.log(response, "GetLeadById");
                const videoEditingHistory = response.data.videoEditingHistory[0];
                setEditingId(videoEditingHistory._id)
                setConvertData({
                    projectName: videoEditingHistory.projectName || "",
                    assignedTo: videoEditingHistory.assignedTo ? [videoEditingHistory.assignedTo] : [],
                    deadline: videoEditingHistory.deadline
                        ? videoEditingHistory.deadline.split('T')[0]
                        : "",
                    comments: videoEditingHistory.comments || "",
                    paymentStatus: videoEditingHistory.paymentStatus || "",
                    totalEditingShots: videoEditingHistory.totalEditingShots || ""
                })
            }
        } catch (error) {
            console.log("Error while fetching lead details", error)
        }
    }

    return (
        <>
            <Helmet>
                <title>Service | Camera Team</title>
            </Helmet>

            <Container>
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                    <Typography variant="h4" gutterBottom>
                        Camera Team
                    </Typography>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "start",
                                backgroundColor: "white",
                                borderRadius: "15px",
                                padding: "4px 12px",
                                boxShadow: 1,
                                marginRight: "20px"
                            }}
                        >
                            <Iconify icon="eva:search-fill" />
                            <InputBase
                                placeholder="Search"
                                sx={{ marginLeft: "8px" }}
                            />
                        </Box>
                        <Box sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: 2 }}>
                            {
                                (role === "Admin" || roleType === "Team Leader") && (
                                    <Tabs
                                        value={activeTab}
                                        onChange={(e, newValue) => setActiveTab(newValue)}
                                        aria-label="content creation views"
                                    >
                                        <Tab label="Calendar View" />
                                        <Tab label="Table View" />
                                    </Tabs>
                                )
                            }
                        </Box>
                    </Box>
                </Stack>

                <Card sx={{ padding: 2, boxShadow: 3, backgroundColor: "#fff" }}>
                    {(role === "Admin" || roleType === "Team Leader") && activeTab === 0 && (
                        <Box sx={{ height: 500 }}>
                            <FullCalendar
                                plugins={[dayGridPlugin, interactionPlugin]}
                                initialView="dayGridMonth"
                                headerToolbar={{
                                    start: "",
                                    center: 'prev title next',
                                    end: ""
                                }}
                                events={events}
                                eventContent={renderEventContent}
                                height="100%"
                            />
                        </Box>
                    )}
                    {
                        ((role === "Admin" || roleType === "Team Leader") && activeTab === 1) || roleType === "Employee" ? (
                            <>
                                <TableContainer component={Paper} sx={{ boxShadow: "none", backgroundColor: "transparent", maxHeight: 350 }}>
                                    {
                                        role === "Admin" || roleType === "Team Leader" ? (
                                            <TableContainer component={Paper} sx={{ boxShadow: "none", backgroundColor: "transparent", maxHeight: 350 }}>
                                                <Table>
                                                    <TableHead>
                                                        <TableCell>S.No</TableCell>
                                                        {/* <TableCell>Assigned User</TableCell> */}
                                                        <TableCell>Lead Name</TableCell>
                                                        {/* <TableCell>Email</TableCell> */}
                                                        <TableCell>Phone</TableCell>
                                                        <TableCell>Shoot Type</TableCell>
                                                        <TableCell>Assigned Task</TableCell>
                                                        <TableCell>Completed Tasks</TableCell>
                                                        <TableCell>File</TableCell>
                                                        <TableCell>Status</TableCell>
                                                        <TableCell></TableCell>
                                                    </TableHead>
                                                    <TableBody>
                                                        {
                                                            assignedLeads.length === 0 ? (
                                                                <TableRow>
                                                                    <TableCell colSpan={9} align="center">
                                                                        No data found
                                                                    </TableCell>
                                                                </TableRow>
                                                            ) : (
                                                                assignedLeads?.map((task, id) => {
                                                                    return (
                                                                        <TableRow key={task?.id}>
                                                                            <TableCell>{calculateIndex(id)}</TableCell>
                                                                            {/* <TableCell>{task?.assignedTo?.name || task?.assignedToHistory[0]?.assignedUser?.name}</TableCell> */}
                                                                            <TableCell>{task?.name}</TableCell>
                                                                            {/* <TableCell>{task?.email}</TableCell> */}
                                                                            <TableCell>{task?.phone}</TableCell>
                                                                            <TableCell>{task?.cameraHistory?.shootType}</TableCell>
                                                                            <TableCell>{task?.cameraHistory?.assignedShots ? task?.cameraHistory?.assignedShots : "-"}</TableCell>
                                                                            <TableCell>{task?.cameraHistory?.completedShots ? task?.cameraHistory?.completedShots : 0} / {task?.cameraHistory?.totalShots}</TableCell>
                                                                            <TableCell>
                                                                                {task?.cameraHistory?.rawFootageUpload?.path ?
                                                                                    <img
                                                                                        src={task?.cameraHistory?.rawFootageUpload?.path
                                                                                            ? `${file_URL + encodeURI(task?.cameraHistory?.rawFootageUpload?.path.replace("public/", ""))}`
                                                                                            : "#"}
                                                                                        alt='Image.png'
                                                                                        style={{ maxWidth: "50px", cursor: "pointer" }}
                                                                                        onClick={() => {
                                                                                            const fullImage = task?.cameraHistory?.rawFootageUpload?.path
                                                                                                ? `${file_URL + encodeURI(task?.cameraHistory?.rawFootageUpload?.path.replace("public/", ""))}`
                                                                                                : "#";
                                                                                            setSelectedImage(fullImage);
                                                                                            setOpenImage(true);
                                                                                        }}
                                                                                    />
                                                                                    : "-"}
                                                                            </TableCell>
                                                                            <TableCell>
                                                                                <Box position="relative" display="inline-flex">
                                                                                    <CircularProgress
                                                                                        variant="determinate"
                                                                                        value={task?.cameraHistory?.progressPercentage}
                                                                                    />
                                                                                    <Box
                                                                                        top={0}
                                                                                        left={0}
                                                                                        bottom={0}
                                                                                        right={0}
                                                                                        position="absolute"
                                                                                        display="flex"
                                                                                        alignItems="center"
                                                                                        justifyContent="center"
                                                                                    >
                                                                                        <Typography variant="caption" component="div" color="text.secondary">
                                                                                            {typeof task?.cameraHistory?.progressPercentage === 'number'
                                                                                                ? `${Math.round(task.cameraHistory.progressPercentage)}%`
                                                                                                : '0%'}
                                                                                        </Typography>
                                                                                    </Box>
                                                                                </Box>
                                                                            </TableCell>
                                                                            <TableCell>
                                                                                <Iconify
                                                                                    icon="material-symbols-light:more-vert"
                                                                                    sx={{ margin: "auto" }}
                                                                                    onClick={(event) => handleOpenMenu(event, task, task._id, task.cameraHistory?.dailyUpdateId)}
                                                                                />
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    )
                                                                })
                                                            )
                                                        }
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        ) : roleType === "Employee" ? (
                                            <TableContainer component={Paper} sx={{ boxShadow: "none", backgroundColor: "transparent", maxHeight: 350 }}>
                                                <Table>
                                                    <TableHead>
                                                        <TableCell>S.No</TableCell>
                                                        <TableCell>Lead</TableCell>
                                                        <TableCell>Contact</TableCell>
                                                        <TableCell>Assigned Work</TableCell>
                                                        <TableCell>Deadline</TableCell>
                                                        <TableCell>Completed Tasks</TableCell>
                                                        <TableCell>File</TableCell>
                                                        <TableCell>Status</TableCell>
                                                        <TableCell></TableCell>
                                                    </TableHead>
                                                    <TableBody>
                                                        {
                                                            assignedLeads?.length === 0 ? (
                                                                <TableRow>
                                                                    <TableCell colSpan={9} align="center">
                                                                        No data found
                                                                    </TableCell>
                                                                </TableRow>
                                                            ) : (
                                                                assignedLeads?.map((work, id) => {
                                                                    return (
                                                                        <TableRow key={work?.id}>
                                                                            <TableCell>{calculateIndex(id)}</TableCell>
                                                                            <TableCell>{work?.name}</TableCell>
                                                                            <TableCell>{work?.phone}</TableCell>
                                                                            {/* <TableCell>{work?.cameraHistory[0]?.projectName}</TableCell> */}
                                                                            <TableCell>{work?.currentWork?.noOfPosters}</TableCell>
                                                                            <TableCell>{work?.currentWork !== null ? new Date(work?.currentWork?.deadline).toLocaleDateString() : "-"}</TableCell>
                                                                            <TableCell>{work?.cameraHistory[0]?.completedShots} / {work?.cameraHistory[0]?.totalShots}</TableCell>
                                                                            <TableCell>
                                                                                <img
                                                                                    src={work?.cameraHistory[0]?.rawFootageUpload?.path
                                                                                        ? `${file_URL + encodeURI(work?.cameraHistory[0]?.rawFootageUpload?.path.replace("public/", ""))}`
                                                                                        : "#"}
                                                                                    alt='Image.png'
                                                                                    style={{ maxWidth: "50px", cursor: "pointer" }}
                                                                                    onClick={() => {
                                                                                        const fullImage = work?.cameraHistory[0]?.rawFootageUpload?.path
                                                                                            ? `${file_URL + encodeURI(work?.cameraHistory[0]?.rawFootageUpload?.path.replace("public/", ""))}`
                                                                                            : "#";
                                                                                        setSelectedImage(fullImage);
                                                                                        setOpenImage(true);
                                                                                    }}
                                                                                />
                                                                            </TableCell>
                                                                            <TableCell align="center">
                                                                                <Box position="relative" display="inline-flex">
                                                                                    <CircularProgress
                                                                                        variant="determinate"
                                                                                        value={work?.cameraHistory[0]?.progressPercentage}
                                                                                    />
                                                                                    <Box
                                                                                        top={0}
                                                                                        left={0}
                                                                                        bottom={0}
                                                                                        right={0}
                                                                                        position="absolute"
                                                                                        display="flex"
                                                                                        alignItems="center"
                                                                                        justifyContent="center"
                                                                                    >
                                                                                        <Typography variant="caption" component="div" color="text.secondary">
                                                                                            {typeof work?.cameraHistory[0]?.progressPercentage === 'number'
                                                                                                ? `${Math.round(work.cameraHistory[0].progressPercentage)}%`
                                                                                                : '0%'}
                                                                                        </Typography>

                                                                                    </Box>
                                                                                </Box>
                                                                            </TableCell>
                                                                            <TableCell>
                                                                                <Iconify
                                                                                    icon="material-symbols-light:more-vert"
                                                                                    sx={{ margin: "auto" }}
                                                                                    onClick={(event) => {
                                                                                        console.log('Work object:', work);
                                                                                        handleOpenMenu(event, work, work._id, work?.cameraHistory[0]?.dailyUpdateId);
                                                                                    }}
                                                                                />
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    )
                                                                })
                                                            )
                                                        }
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        ) : null
                                    }
                                </TableContainer>
                                <PaginationComponent
                                    name={"Leads"}
                                    totalcount={totalCount}
                                    limit={limit}
                                    handleLimitChange={handleLimitChange}
                                    handlePrevPage={handlePrevPage}
                                    handleNextPage={handleNextPage}
                                    currentPage={currentPage}
                                    totalPages={totalPages}
                                />
                            </>
                        ) : null}
                </Card>

                {/* Dialog for Adding Task */}
                <Dialog open={formOpen} onClose={() => setFormOpen(false)}>
                    <DialogTitle>Daily Work Update!</DialogTitle>
                    <DialogContent>
                        <TextField
                            margin="dense"
                            label="Completed Shots"
                            name="completedShots"
                            value={formData.completedShots}
                            onChange={handleChange}
                            type="number"
                            fullWidth
                        />
                        <TextField
                            margin="dense"
                            label="Comments"
                            name="comments"
                            value={formData.comments}
                            onChange={handleChange}
                            multiline
                            fullWidth
                        />
                        {/* <TextField
                            name="status"
                            label="Status"
                            fullWidth
                            select
                            margin="dense"
                            value={formData.status}
                            onChange={handleChange}
                        >
                            <MenuItem value="Pending">Pending</MenuItem>
                            <MenuItem value="In Progress">In Progress</MenuItem>
                            <MenuItem value="Completed">Completed</MenuItem>
                        </TextField> */}
                        <TextField
                            margin='dense'
                            type='file'
                            hidden
                            label="Upload File"
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            onChange={(e) => handleFileChange(e)}
                        >
                        </TextField>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setFormOpen(false)} color="secondary">Cancel</Button>
                        <Button color="primary" onClick={postDailyWorkUpdate}>Update</Button>
                    </DialogActions>
                </Dialog>

                {/* Edit Menu  */}
                <Popover
                    open={Boolean(open)}
                    anchorEl={open}
                    onClose={handleCloseMenu}
                    anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                    PaperProps={{
                        sx: {
                            p: 1,
                            width: 140,
                            '& .MuiMenuItem-root': {
                                px: 1,
                                typography: 'body2',
                                borderRadius: 0.75,
                            },
                        },
                    }}
                >
                    {role === "Admin" ? (
                        <>
                            <MenuItem onClick={handleOpenDialog}>
                                <Iconify icon={'material-symbols:visibility'} sx={{ mr: 2 }} />
                                View
                            </MenuItem>
                            <MenuItem onClick={() => handleFormOpen(selectedLeadId)}>
                                <Iconify icon="material-symbols:sync-alt" sx={{ mr: 2 }} />
                                Assign To
                            </MenuItem>
                        </>
                    ) : roleType === "Team Leader" ? (
                        <>
                            <MenuItem onClick={handleOpenDialog}>
                                <Iconify icon={'material-symbols:visibility'} sx={{ mr: 2 }} />
                                View
                            </MenuItem>
                            <MenuItem onClick={() => handleFormOpen(selectedLeadId)}>
                                <Iconify icon="material-symbols:sync-alt" sx={{ mr: 2 }} />
                                Convert
                            </MenuItem>
                        </>
                    ) : (
                        <>
                            <MenuItem onClick={handleOpenDialog}>
                                <Iconify icon={'material-symbols:visibility'} sx={{ mr: 2 }} />
                                View
                            </MenuItem>
                            <MenuItem onClick={handleOpen}>
                                <Iconify icon={'eva:edit-fill'} sx={{ mr: 1 }} />
                                Work Update
                            </MenuItem>

                            {/* <MenuItem sx={{ color: 'error.main' }}>
                                <Iconify icon={'eva:trash-2-outline'} sx={{ mr: 2 }} />
                                Delete
                            </MenuItem> */}
                        </>
                    )}
                </Popover>

                <Dialog
                    open={details}
                    onClose={handleCloseDialog}
                    scroll={scroll}
                    aria-labelledby="scroll-dialog-title"
                    aria-describedby="scroll-dialog-description"
                    sx={{ maxWidth: 700, width: "100%", margin: "0 auto" }}
                >
                    <DialogTitle id="scroll-dialog-title">
                        <Typography variant="h5" component="div" sx={{ fontWeight: 'bold' }}>
                            Daily Work Updates
                        </Typography>
                    </DialogTitle>
                    <DialogContent dividers={scroll === 'paper'}>
                        <DialogContentText
                            id="scroll-dialog-description"
                            ref={descriptionElementRef}
                            component="div" // Ensure DialogContentText renders as a div to contain Box/Grid
                        >
                            {!view || Object.keys(view).length === 0 ? (
                                <Box sx={{ p: 3, textAlign: 'center' }}>
                                    <Typography variant="h6" color="text.secondary">No data found</Typography>
                                </Box>
                            ) : (
                                <Box sx={{ p: 1 }}>
                                    <Paper elevation={3} sx={{
                                        p: 2,
                                        backgroundColor: '#ffffff',
                                        borderRadius: 2,
                                        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
                                        borderLeft: '5px solid #1976d2' // A subtle accent line
                                    }}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} id="paddingTop">
                                                <Typography variant="h6" sx={{ color: '#333' }}>
                                                    Project Details
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Name: {view?.name}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Shoot Type: {view?.cameraHistory?.shootType}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Deadline: {new Date(view?.cameraHistory?.deadline).toLocaleDateString()}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    location : {view?.cameraHistory?.location}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Project Name: {view?.videoEditingHistory?.projectName}
                                                </Typography>
                                            </Grid>
                                            {/* <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Status: <Typography component="span" sx={{
                                                        fontWeight: 'bold',
                                                        color: view?.cameraHistory?.status === 'Completed' ? 'success.main' :
                                                            view?.cameraHistory?.status === 'In Progress' ? 'warning.main' : 'error.main'
                                                    }}>
                                                        {view?.cameraHistory?.status}
                                                    </Typography>
                                                </Typography>
                                            </Grid> */}
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Amount : {view?.cameraHistory?.amount}
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={12} id="paddingTop">
                                                <Typography variant="h6" sx={{ color: '#333' }}>
                                                    Task Progress
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Completed Shots: {view?.cameraHistory?.completedShots}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body1">
                                                    Total Videos: {view?.cameraHistory?.totalShots}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} id="paddingTop">
                                                <Typography variant="body1">
                                                    Progress: <Typography component="span" sx={{ fontWeight: 'bold', color: '#007bff' }}>
                                                        {view?.cameraHistory?.progressPercentage}%
                                                    </Typography>
                                                </Typography>
                                            </Grid>

                                            {view?.[0]?.cameraHistory?.comments && (
                                                <Grid item xs={12} id="paddingTop">
                                                    <Typography variant="h6" sx={{ mt: 2, mb: 1, color: '#333' }}>
                                                        Comments
                                                    </Typography>
                                                    <Typography variant="body2" sx={{ fontStyle: 'italic', color: 'text.secondary' }}>
                                                        "{view?.[0]?.cameraHistory?.comments}"
                                                    </Typography>
                                                </Grid>
                                            )}

                                            <Grid item xs={12} id="paddingTop">
                                                <Typography variant="h6" sx={{ color: '#333' }}>
                                                    Timestamps
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body2" color="text.secondary">
                                                    Created: {new Date(view?.createdAt).toLocaleString()}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={6} id="paddingTop">
                                                <Typography variant="body2" color="text.secondary">
                                                    Updated: {new Date(view?.updatedAt).toLocaleString()}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                        {
                                            roleType === "Employee" && (
                                                <TableContainer component={Paper} sx={{ marginTop: 2 }}>
                                                    <Table sx={{ minWidth: 350 }} aria-label="customized table">
                                                        <TableBody>
                                                            {/* Employee content history */}
                                                            {roleType === "Employee" && view?.contentCreationHistory?.length > 0 && (
                                                                <>
                                                                    {/* Title Row */}
                                                                    <TableRow>
                                                                        <TableCell
                                                                            colSpan={4}
                                                                            align="left"
                                                                            sx={{ fontWeight: "bold", fontSize: "16px", background: "#f5f5f5" }}
                                                                        >
                                                                            Content Creation History
                                                                        </TableCell>
                                                                    </TableRow>

                                                                    {view.contentCreationHistory.map((history, hIndex) => {
                                                                        const filePath = history?.fileUpload?.path?.toLowerCase() || "";
                                                                        const fileUrl = history?.fileUpload?.path
                                                                            ? `${file_URL + encodeURI(
                                                                                history.fileUpload.path.replace("public/", "")
                                                                            )}`
                                                                            : null;

                                                                        return (
                                                                            <TableRow
                                                                                key={`content-${hIndex}`}
                                                                                hover
                                                                                onClick={() => fileUrl && window.open(fileUrl, "_blank")}
                                                                            >
                                                                                <TableCell align="center">{hIndex + 1}</TableCell>
                                                                                <TableCell align="center">
                                                                                    {fileUrl ? (
                                                                                        filePath.endsWith(".docx") ? (
                                                                                            <a href={fileUrl} target="_blank" rel="noopener noreferrer">
                                                                                                <img src={wordIcon} alt="Word" height="40" width="40" />
                                                                                            </a>
                                                                                        ) : filePath.endsWith(".pdf") ? (
                                                                                            <a href={fileUrl} target="_blank" rel="noopener noreferrer">
                                                                                                <img src={pdfIcon} alt="PDF" height="40" width="40" />
                                                                                            </a>
                                                                                        ) : filePath.match(/\.(jpg|jpeg|png|webp|avif)$/) ? (
                                                                                            <img
                                                                                                src={fileUrl}
                                                                                                alt="Uploaded"
                                                                                                style={{ maxWidth: "40px", cursor: "pointer" }}
                                                                                            />
                                                                                        ) : (
                                                                                            <span style={{ fontSize: "18px" }}>-</span>
                                                                                        )
                                                                                    ) : (
                                                                                        "-"
                                                                                    )}
                                                                                </TableCell>
                                                                                <TableCell align="center">{history?.comments || "-"}</TableCell>
                                                                                <TableCell align="center">
                                                                                    {history?.updatedAt
                                                                                        ? new Date(history.updatedAt).toLocaleString()
                                                                                        : "-"}
                                                                                </TableCell>
                                                                            </TableRow>
                                                                        );
                                                                    })}
                                                                </>
                                                            )}

                                                            {/* Camera history */}
                                                            {roleType === "Employee" && view?.cameraHistory?.length > 0 && (
                                                                <>
                                                                    {/* Title Row */}
                                                                    <TableRow>
                                                                        <TableCell
                                                                            colSpan={4}
                                                                            align="left"
                                                                            sx={{ fontWeight: "bold", fontSize: "16px", background: "#f5f5f5" }}
                                                                        >
                                                                            Camera History
                                                                        </TableCell>
                                                                    </TableRow>

                                                                    {view.cameraHistory.map((history, hIndex) => {
                                                                        const filePath = history?.fileUpload?.path?.toLowerCase() || "";
                                                                        const fileUrl = history?.fileUpload?.path
                                                                            ? `${file_URL + encodeURI(
                                                                                history.fileUpload.path.replace("public/", "")
                                                                            )}`
                                                                            : null;

                                                                        return (
                                                                            <TableRow
                                                                                key={`camera-${hIndex}`}
                                                                                hover
                                                                                onClick={() => fileUrl && window.open(fileUrl, "_blank")}
                                                                            >
                                                                                <TableCell align="center">{hIndex + 1}</TableCell>
                                                                                <TableCell align="center">
                                                                                    {fileUrl ? (
                                                                                        filePath.endsWith(".docx") ? (
                                                                                            <a href={fileUrl} target="_blank" rel="noopener noreferrer">
                                                                                                <img src={wordIcon} alt="Word" height="40" width="40" />
                                                                                            </a>
                                                                                        ) : filePath.endsWith(".pdf") ? (
                                                                                            <a href={fileUrl} target="_blank" rel="noopener noreferrer">
                                                                                                <img src={pdfIcon} alt="PDF" height="40" width="40" />
                                                                                            </a>
                                                                                        ) : filePath.match(/\.(jpg|jpeg|png|webp|avif)$/) ? (
                                                                                            <img
                                                                                                src={fileUrl}
                                                                                                alt="Uploaded"
                                                                                                style={{ maxWidth: "40px", cursor: "pointer" }}
                                                                                            />
                                                                                        ) : (
                                                                                            <span style={{ fontSize: "18px" }}>-</span>
                                                                                        )
                                                                                    ) : (
                                                                                        "-"
                                                                                    )}
                                                                                </TableCell>
                                                                                <TableCell align="center">{history?.comments || "-"}</TableCell>
                                                                                <TableCell align="center">
                                                                                    {history?.updatedAt
                                                                                        ? new Date(history.updatedAt).toLocaleString()
                                                                                        : "-"}
                                                                                </TableCell>
                                                                            </TableRow>
                                                                        );
                                                                    })}
                                                                </>
                                                            )}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            )
                                        }
                                    </Paper>
                                </Box>
                            )}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions sx={{ p: 2 }}>
                        <Button onClick={handleCloseDialog} variant="contained" color="primary">Close</Button>
                    </DialogActions>
                </Dialog>

                {/* Convert leads */}
                <Dialog open={convertForm} sx={{ display: "unset" }}>
                    <DialogTitle>Convert Leads</DialogTitle>
                    <DialogContent>
                        {
                            role === "Admin" ? (
                                <>
                                    <TextField
                                        name="projectName"
                                        label="Project Name"
                                        fullWidth
                                        margin="dense"
                                        value={convertData.projectName}
                                        onChange={handleInputChange}
                                        required
                                    />
                                    <TextField
                                        name="assignedTo"
                                        label="Assigned To"
                                        fullWidth
                                        select
                                        margin="dense"
                                        value={convertData.assignedTo}
                                        onChange={handleInputChange}
                                        required
                                    >
                                        {employeeOptions.map((editor) => (
                                            <MenuItem key={editor.id} value={editor.id}>
                                                {editor.name}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                    <TextField
                                        name="deadline"
                                        label="Deadline"
                                        type="date"
                                        fullWidth
                                        margin="dense"
                                        InputLabelProps={{ shrink: true }}
                                        value={convertData.deadline}
                                        onChange={handleInputChange}
                                        required
                                    />
                                    {/* <TextField
                                        name="totalEditingShots"
                                        label="Total Editing Shots"
                                        fullWidth
                                        type='number'
                                        margin="dense"
                                        value={convertData.totalEditingShots}
                                        onChange={handleInputChange}
                                    /> */}
                                    <div style={{ display: "flex", justifyContent: "flex-start" }}>
                                        <Typography variant="body1" style={{ margin: "5px 0px 0px 10px" }} gutterBottom>
                                            Total Shots: {convertData.totalEditingShots ? convertData.totalEditingShots : "-"}
                                        </Typography>
                                        <Typography
                                            variant="body1"
                                            style={{ margin: "5px 0px 0px 10px" }}
                                            gutterBottom
                                        >
                                            Pending Shots: {view?.cameraHistory?.totalShots - view?.cameraHistory?.completedShots}
                                        </Typography>
                                    </div>
                                    <TextField
                                        name="assignedEditingShots"
                                        label="Shots to Assign"
                                        fullWidth
                                        type='number'
                                        margin="dense"
                                        value={convertData.assignedEditingShots}
                                        onChange={handleInputChange}
                                    />
                                    <TextField
                                        name="comments"
                                        label="Additional Comments"
                                        fullWidth
                                        multiline
                                        rows={3}
                                        margin="dense"
                                        value={convertData.comments}
                                        onChange={handleInputChange}
                                    />
                                    <TextField margin="dense" select label="Payment Status" name="paymentStatus" value={convertData.paymentStatus || ''} onChange={handleInputChange} fullWidth>
                                        {["Pending", "Completed"].map(p => (
                                            <MenuItem key={p} value={p}>{p}</MenuItem>
                                        ))}
                                    </TextField>
                                </>
                            ) : roleType === "Team Leader" ? (
                                <>
                                    <FormControl fullWidth margin="dense">
                                        <InputLabel id="assign-to-label">Assign To</InputLabel>
                                        <Select
                                            labelId="assign-to-label"
                                            multiple
                                            value={convertData.assignedTo}
                                            onChange={handleMultiSelectChange}
                                            InputLabelProps={{ shrink: true }}
                                            label="Assign To"
                                            input={<OutlinedInput label="Assign To" />}
                                            renderValue={(selected) => (
                                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                                    {selected.map((value) => {
                                                        const employee = employeeOptions.find(emp => emp.id === value);
                                                        return employee ? (
                                                            <Chip key={value} label={employee.name} />
                                                        ) : null;
                                                    })}
                                                </Box>
                                            )}
                                            fullWidth
                                        >
                                            {employeeOptions.map((emp) => (
                                                <MenuItem key={emp.id} value={emp.id}>
                                                    {emp.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                    <Box sx={{ mt: 2 }}>
                                        {convertData.assignedTo.length > 0 && convertData.assignedTo.map((empId) => {
                                            const employee = employeeOptions.find(emp => emp.id === empId);
                                            return employee && (
                                                <>
                                                    <Box key={empId} sx={{ display: 'flex', alignItems: 'center', mb: 1, gap: 2 }}>
                                                        <div style={{ display: "flex", justifyContent: "center", gap: "20px" }}>
                                                            <div className='col' style={{ marginTop: "5px" }}>
                                                                <Typography>{employee.name}</Typography>
                                                            </div>
                                                        </div>
                                                    </Box>
                                                    <Box key={empId} sx={{ alignItems: 'center', mb: 1, gap: 2 }}>
                                                        <div style={{ display: "flex", justifyContent: "center", gap: "20px", marginBottom: "10px" }}>
                                                            <TextField
                                                                label="No of Posters"
                                                                value={convertData.employeeWork?.[empId]?.noOfPosters || ""}
                                                                onChange={(e) => {
                                                                    const work = e.target.value;
                                                                    setConvertData(prev => ({
                                                                        ...prev,
                                                                        employeeWork: {
                                                                            ...prev.employeeWork,
                                                                            [empId]: {
                                                                                ...prev.employeeWork?.[empId],
                                                                                noOfPosters: work
                                                                            }
                                                                        }
                                                                    }));
                                                                }}
                                                                size="small"
                                                                fullWidth
                                                            />
                                                            <TextField
                                                                label="Deadline"
                                                                value={convertData.employeeWork?.[empId]?.deadline || ""}
                                                                onChange={(e) => {
                                                                    const work = e.target.value;
                                                                    setConvertData(prev => ({
                                                                        ...prev,
                                                                        employeeWork: {
                                                                            ...prev.employeeWork,
                                                                            [empId]: {
                                                                                ...prev.employeeWork?.[empId],
                                                                                deadline: work
                                                                            }
                                                                        }
                                                                    }));
                                                                }}
                                                                type='date'
                                                                size="small"
                                                                fullWidth
                                                                InputLabelProps={{ shrink: true }}
                                                            />
                                                        </div>
                                                    </Box>
                                                </>
                                            );
                                        })}
                                    </Box>
                                </>
                            ) : null
                        }
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleFormClose} color="secondary">Cancel</Button>
                        <Button onClick={convertLeads} color="primary">Submit</Button>
                    </DialogActions>
                </Dialog>

                <Dialog open={openImage} onClose={() => setOpenImage(false)} maxWidth="md">
                    <Iconify
                        icon="material-symbols:close"
                        onClick={() => setOpenImage(false)}
                        style={{
                            position: 'absolute',
                            top: 10,
                            right: 10,
                            fontSize: 24,
                            cursor: 'pointer',
                            zIndex: 1
                        }}
                    />
                    <DialogContent>
                        <img src={selectedImage} alt="Full View" style={{ width: "100%", height: "auto" }} />
                    </DialogContent>
                </Dialog>

            </Container>
        </>
    );
}

function renderEventContent(eventInfo) {
    const isDeadline = eventInfo.event.extendedProps.type === 'deadline';
    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: isDeadline ? '#FFEBEE' : '#F5F5F5',
            borderRadius: '8px',
            padding: '6px',
            marginTop: '5px',
            boxShadow: 2,
            fontSize: '12px',
            color: 'black',
            maxWidth: "125px",
            borderLeft: `4px solid ${eventInfo.event.backgroundColor || '#90CAF9'}`
        }}>
            <Box sx={{
                borderLeft: `4px solid ${eventInfo.event.extendedProps.color || '#90CAF9'}`,
                paddingLeft: '6px'
            }}>
                {isDeadline ? (
                    <>
                        <strong>⏰</strong>
                        <div>Lead: {eventInfo.event.extendedProps.leadName}</div>
                        <div>Progress: {eventInfo.event.extendedProps.progress}</div>
                    </>
                ) : (
                    <>
                        <strong>📝 {eventInfo.event.title}</strong>
                        <div>Lead: {eventInfo.event.extendedProps.leadName}</div>
                        <div>Req: {eventInfo.event.extendedProps.requirement}</div>
                        <div>Status: {eventInfo.event.extendedProps.status}</div>
                        <div>Progress: {eventInfo.event.extendedProps.progress}</div>
                    </>
                )}
            </Box>
        </Box>
    );
}

export default CameraTeam;